import { configureStore } from '@reduxjs/toolkit'

import adminSlice from '@app/redux/slices/adminSlice'
import userSlice from '@app/redux/slices/userSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    admin: adminSlice,
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
